import { render } from "./ItLayout.vue?vue&type=template&id=352115a0&scoped=true"
const script = {}

import "./ItLayout.vue?vue&type=style&index=0&id=352115a0&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352115a0"]])

export default __exports__